import { useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useOperationsService, ActivityLog, ActivityLogFilters } from '../services/operationsService';
import { kernelKeys } from './queryKeys';

export function useActivityLog(filters?: ActivityLogFilters) {
  const service = useOperationsService();

  const query = useQuery({
    queryKey: kernelKeys.activityLog(filters),
    queryFn: () => service.getActivityLog(filters),
  });

  const { refetch } = query;
  const refresh = useCallback(() => {
    refetch();
  }, [refetch]);

  return {
    data: (query.data ?? null) as ActivityLog | null,
    loading: query.isFetching,
    error: query.error
      ? query.error instanceof Error
        ? query.error.message
        : 'Failed to load activity log'
      : null,
    refresh,
  };
}
